(function () {
document.querySelectorAll('[data-pnp]').forEach(function (section) {
if (section.dataset.pnpInit === '1') return;
section.dataset.pnpInit = '1';
initSection(section);
});
function initSection(section) {
var data = section.dataset;
var labels = { idle: data.pnpIdle, done: data.pnpDone, error: data.pnpError, note: data.pnpNote };
var button = section.querySelector('[data-pnp-add]');
var buttonLabel = section.querySelector('.pnp-button-label');
var feedback = section.querySelector('[data-pnp-feedback]');
var parts = section.querySelectorAll('[data-pnp-item]');
var groups = section.querySelectorAll('.pnp-swatches[data-pnp-group]');
var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function productUrl(path) {
if (!path) return '#';
return path.indexOf('/products/') === 0 ? root.replace(/\/$/, '') + path : path;
}
section.classList.add('is-ready');
if (reduceMotion || !('IntersectionObserver' in window)) {
section.classList.add('is-visible');
} else {
var observer = new IntersectionObserver(function (entries) {
entries.forEach(function (entry) {
if (!entry.isIntersecting) return;
section.classList.add('is-visible');
observer.unobserve(section);
});
}, { threshold: 0.2 });
observer.observe(section);
}
function applyChoice(swatch, animate) {
var group = swatch.closest('.pnp-swatches[data-pnp-group]');
var card = group && section.querySelector('[data-pnp-row="' + group.dataset.pnpGroup + '"]');
var chosen = group && group.parentNode.querySelector('[data-pnp-choice]');
if (chosen) chosen.textContent = swatch.dataset.pnpValue || '';
if (!card) return;
var choice = swatch.dataset;
var image = card.querySelector('img');
if (image && choice.pnpThumb && image.getAttribute('src') !== choice.pnpThumb) {
if (animate && !reduceMotion) {
image.classList.add('is-swapping');
setTimeout(function () {
image.src = choice.pnpThumb;
image.classList.remove('is-swapping');
}, 160);
} else {
image.src = choice.pnpThumb;
}
}
if (choice.pnpVariant) card.dataset.pnpVariant = choice.pnpVariant;
if (choice.pnpImage) card.dataset.pnpImage = choice.pnpImage;
if (choice.pnpUrl) card.dataset.pnpUrl = choice.pnpUrl;
if (choice.pnpText !== undefined) card.dataset.pnpText = choice.pnpText;
if (card.hasAttribute('data-pnp-follows') && choice.pnpName) {
card.dataset.pnpName = choice.pnpName;
var name = card.querySelector('.pnp-item-name');
if (name) name.textContent = choice.pnpName;
if (image) image.alt = choice.pnpName;
}
}
groups.forEach(function (group) {
group.querySelectorAll('.pnp-swatch').forEach(function (swatch) {
swatch.addEventListener('click', function () {
group.querySelectorAll('.pnp-swatch').forEach(function (node) {
var active = node === swatch;
node.classList.toggle('is-active', active);
node.setAttribute('aria-checked', active ? 'true' : 'false');
});
applyChoice(swatch, true);
setFeedback('');
});
});
var active = group.querySelector('.pnp-swatch.is-active');
if (active) applyChoice(active, false);
});
function components() {
var bundle = data.pnpBundle;
var uid = bundle + '-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
var items = [];
parts.forEach(function (card) {
var id = parseInt(card.dataset.pnpVariant, 10);
if (!id) return;
items.push({
id: id,
quantity: parseInt(card.dataset.pnpQty, 10) || 1,
properties: { _bundle_id: bundle, _bundle_uid: uid }
});
});
return items;
}
var modal = section.querySelector('[data-pnp-modal]');
var modalImage = section.querySelector('[data-pnp-modal-image]');
var modalTitle = section.querySelector('[data-pnp-modal-title]');
var modalText = section.querySelector('[data-pnp-modal-text]');
var modalLink = section.querySelector('[data-pnp-modal-link]');
var lastTrigger = null;
function openModal(trigger) {
if (!trigger || !modal) return;
var item = trigger.dataset;
lastTrigger = trigger;
if (modalImage) {
modalImage.src = item.pnpImage || '';
modalImage.alt = item.pnpName || '';
modalImage.parentNode.hidden = !item.pnpImage;
}
if (modalTitle) modalTitle.textContent = item.pnpName || '';
if (modalText) modalText.textContent = item.pnpText || '';
if (modalLink) modalLink.href = productUrl(item.pnpUrl);
modal.hidden = false;
requestAnimationFrame(function () {
modal.classList.add('is-open');
});
var closeButton = modal.querySelector('.pnp-modal-close');
if (closeButton) closeButton.focus();
}
function closeModal() {
if (!modal || modal.hidden) return;
modal.classList.remove('is-open');
setTimeout(function () {
modal.hidden = true;
if (lastTrigger) {
lastTrigger.focus();
lastTrigger = null;
}
}, 260);
}
section.querySelectorAll('[data-pnp-item]').forEach(function (card) {
card.addEventListener('click', function () {
openModal(card);
});
});
if (modalLink) {
modalLink.addEventListener('click', function (event) {
var href = modalLink.getAttribute('href');
if (!href || href === '#') return;
event.preventDefault();
event.stopPropagation();
window.open(href, '_blank', 'noopener');
});
}
if (modal) {
modal.querySelectorAll('[data-pnp-close]').forEach(function (node) {
node.addEventListener('click', closeModal);
});
document.addEventListener('keydown', function (event) {
if (event.key === 'Escape') closeModal();
});
}
function setFeedback(message, isError) {
if (!feedback) return;
feedback.textContent = message || '';
feedback.classList.toggle('is-error', Boolean(isError));
}
function flyToCart() {
if (reduceMotion) return;
var target =
document.querySelector('#cart-icon-bubble') ||
document.querySelector('[href$="/cart"]') ||
document.querySelector('.header__icon--cart');
if (!target) return;
var targetBox = target.getBoundingClientRect();
section.querySelectorAll('[data-pnp-item] img').forEach(function (image, index) {
var box = image.getBoundingClientRect();
var clone = image.cloneNode(true);
clone.className = 'pnp-fly';
clone.style.left = box.left + 'px';
clone.style.top = box.top + 'px';
clone.style.width = box.width + 'px';
clone.style.height = box.height + 'px';
clone.style.transition = 'transform 0.85s cubic-bezier(.6,.05,.35,1), opacity 0.85s ease';
document.body.appendChild(clone);
requestAnimationFrame(function () {
setTimeout(function () {
var dx = targetBox.left + targetBox.width / 2 - (box.left + box.width / 2);
var dy = targetBox.top + targetBox.height / 2 - (box.top + box.height / 2);
clone.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.18)';
clone.style.opacity = '0.15';
}, index * 110);
});
setTimeout(function () {
clone.remove();
}, 1200 + index * 110);
});
}
function drawerNow() {
var el = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
if (el && typeof el.renderContents === 'function' && typeof el.getSectionsToRender === 'function') {
return el;
}
return null;
}
function refreshCart(sections) {
try {
if (sections) {
var bubble = document.getElementById('cart-icon-bubble');
if (bubble && sections['cart-icon-bubble']) {
var parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
var fresh = parsed.getElementById('cart-icon-bubble');
if (fresh) bubble.innerHTML = fresh.innerHTML;
}
var drawer = document.querySelector('cart-drawer');
if (drawer && sections['cart-drawer']) {
var parsedDrawer = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
var freshDrawer = parsedDrawer.querySelector('cart-drawer');
if (freshDrawer) drawer.innerHTML = freshDrawer.innerHTML;
}
}
document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
} catch (error) {
}
}
function addItems(items, drawer) {
var payload = {
items: items,
sections: drawer ? drawer.getSectionsToRender().map(function (s) { return s.id; })
: ['cart-drawer', 'cart-icon-bubble'],
sections_url: window.location.pathname
};
return fetch(root.replace(/\/$/, '') + '/cart/add.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json',
Accept: 'application/json',
'X-Requested-With': 'XMLHttpRequest'
},
body: JSON.stringify(payload)
}).then(function (response) {
return response.text().then(function (raw) {
var payload = {};
try { payload = JSON.parse(raw); } catch (error) { payload = {}; }
return { ok: response.ok, data: payload };
});
}).catch(function () {
return { ok: false, data: {} };
});
}
if (button) {
button.type = 'button';
button.addEventListener('click', function (event) {
event.preventDefault();
if (button.classList.contains('is-loading')) return;
var items = components();
if (items.length !== parts.length) {
setFeedback(labels.error || '', true);
return;
}
var drawer = drawerNow();
if (drawer && typeof drawer.setActiveElement === 'function') {
drawer.setActiveElement(button);
}
button.classList.remove('is-done');
button.classList.add('is-loading');
setFeedback('');
addItems(items, drawer)
.then(function (result) {
button.classList.remove('is-loading');
if (!result.ok || (result.data && result.data.status)) {
button.classList.remove('is-done');
if (buttonLabel) buttonLabel.textContent = labels.idle || 'Add to Cart';
setFeedback((result.data && (result.data.description || result.data.message)) || labels.error || '', true);
return;
}
button.classList.add('is-done');
if (buttonLabel) buttonLabel.textContent = labels.done || 'Added to cart';
flyToCart();
var payload = result.data || {};
if (drawer && payload.sections) {
if (!payload.id && Array.isArray(payload.items) && payload.items.length) {
payload.id = payload.items[0].id;
}
drawer.renderContents(payload);
drawer.classList.remove('is-empty');
} else {
refreshCart(payload.sections);
}
setFeedback(labels.note || '');
setTimeout(function () {
button.classList.remove('is-done');
if (buttonLabel) buttonLabel.textContent = labels.idle || 'Add to Cart';
}, 2600);
})
.catch(function () {
button.classList.remove('is-loading', 'is-done');
setFeedback(labels.error || '', true);
});
});
}
}
})();